// @ts-strict-ignore
import React from 'react';
import {
  Badge, Box, Icon, IconName,
} from '@usealloy/component-library';
import { capitalize } from '~/analytics/utils/helpers';
import type { BadgeStatus, WebhookAuditEventDetails } from '~/investigations/redux/types';

export const TransactionStatusBadge = ({
  externalTransactionId, status, webhookAuditEventDetailsByTransactionId,
}: {
  externalTransactionId?: string;
  status: string;
  webhookAuditEventDetailsByTransactionId?: { [transactionId: string]: WebhookAuditEventDetails };
}) => {
  const text = capitalize(status);

  const config: BadgeStatus = {
    accepted: { icon: IconName.ThumbsUp, status: 'eventSuccess' },
    paused: { icon: IconName.CirclePause, status: 'info' },
    rejected: { icon: IconName.ThumbsDown, status: 'eventRejected' },
  };

  const { icon, status: badgeStatus } = config[status.toLowerCase()] || {
    icon: null,
    status: 'neutral',
  };

  const pendingStatusChange = (
    webhookAuditEventDetailsByTransactionId?.[externalTransactionId]
    && status === 'Paused'
  );

  const pendingStatusText = (
    webhookAuditEventDetailsByTransactionId?.[externalTransactionId]?.value_to
  );

  const { icon: pendingIcon, status: pendingStatus } = (
    config[pendingStatusText?.toLowerCase()] || {}
  );

  return pendingStatusChange
    ? (
      <Box justifyContent="flex-start">
        <Badge
          icon={icon}
          iconSize="small"
          status={badgeStatus}
        >
          {text}
        </Badge>
        <Icon
          icon={IconName.ArrowRight}
          size="small"
          style={{
            marginLeft: 'var(--cl-space-2)',
            marginRight: 'var(--cl-space-2)',
            minHeight: 16,
            minWidth: 16,
          }}
        />
        <Badge
          icon={pendingIcon}
          iconSize="small"
          status={(
            pendingStatus
          )}
        >
          {pendingStatusText}
        </Badge>
      </Box>
    ) : (
      <Badge
        icon={icon}
        iconSize="small"
        status={badgeStatus}
      >
        {text}
      </Badge>
    );
};
